import React from "react";
import _pubA97D53F3 from "./atoms.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import "./StatusCodeDot.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_cf61450b _54a8ca1c _pub-54a8ca1c _pub-a97d53f3" + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : "") + (props["active"] ? " " + "_54a8ca1c_active _pub-54a8ca1c_active _pub-a97d53f3_active active" : "") + (props["warning"] ? " " + "_54a8ca1c_warning _pub-54a8ca1c_warning _pub-a97d53f3_warning warning" : "") + (props["disabled"] ? " " + "_54a8ca1c_disabled _pub-54a8ca1c_disabled _pub-a97d53f3_disabled disabled" : "") + (props["inactive"] ? " " + "_54a8ca1c_inactive _pub-54a8ca1c_inactive _pub-a97d53f3_inactive inactive" : ""),
    "ref": ref,
    "style": castStyle(props["style"]),
  }, null)
}));
export default $$Default;


